module.exports = __webpack_public_path__ + "h5/img/qingyun8.d6fe2c07.png";